import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalOverviewComponent } from '../../common/modal-overview/modal-overview.component';
import { Router } from '@angular/router';
import { logbaseService } from '../../services/logbase.service';
import { PfepService } from '../../services/pfepService';
import { RackTableData } from '../../models/pfepModels';
//import { Spinner } from 'primeng/primeng';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
//import { t } from '@angular/core/src/render3';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { PfepHistoryComponent } from '../../common/pfep-history/pfep-history.component';
import { AddRackNoubaPopupComponent } from '../../common/add-rack-nouba-popup/add-rack-nouba-popup.component';
import { SelectionModel } from '@angular/cdk/collections';
export interface User {
  name: string;
}
@Component({
  selector: 'app-rack-upload',
  templateUrl: './rack-upload.component.html',
  styleUrls: ['./rack-upload.component.scss']
})
export class RackUploadComponent implements OnInit {
  Rack_Data: RackTableData[] = [];
  // tslint:disable-next-line: max-line-length
  displayedColumns = ['select', 'rackCode', 'drivingDirection', 'x', 'y', 'depth', 'width', 'height', 'building', 'shelfCount', 'columnCount', 'history', 'delete'];
  dataSource = new MatTableDataSource<RackTableData>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('rackPage') rackPage: ElementRef;
  @ViewChild('rackInput') rackInput: ElementRef;
  file: File = null;
  removable = true;
  buildings = new FormControl([]);
  buildingsArr = [];
  buildingArrLength:number = 0;
  rackCode = new FormControl('', [Validators.required, Validators.maxLength(8)]);
  fontSize = 16;
  length;
  pageSize = 10;
  downloadRackData;
  pageSizeOptions = [10, 20, 30, 50, 100];
  formData = {};
  buildingNumberList = [];
  rackDownloadValues = [];
  selection = new SelectionModel<RackTableData>(true, []);
  options: string[] = [];
  rackCodeFilteredOptions: string[];
  noRackCodeRecords: string = '';
  bulkDeleteRack = [];
  @ViewChild('rackCodeInput') rackCodeInput: ElementRef;
  rackCodeLength: number = 0;
  constructor(public snackBar: MatSnackBar, private fb: FormBuilder, public dialog: MatDialog,
    private router: Router, private pfepService: PfepService, private spinner: NgxSpinnerService,) {

  }
  ngOnInit() {
    this.getBuildingNumbers();
    this.getRackTableData();
    this.buildingArrLength = this.buildings.value.length;
  }

  getRackCodeData(code) {
    // this.spinner.show();
    this.pfepService.getRackCodes(code).subscribe(response => {
      if (response.status && response.status.statusCode === 200) {
        // this.spinner.hide();
        const rackCodeArray = response.result;
        this.rackCodeFilteredOptions = rackCodeArray;
        if (response.result.length === 0) {
          this.noRackCodeRecords = 'No Rack Codes Found';
        }
      }
    }, error => {
      this.spinner.hide();
    });
  }

  getRackCodeChar(e) {
    const rackCodeChar = this.rackCodeInput.nativeElement.value;
    this.rackCodeLength = this.rackCodeInput.nativeElement.value.length;
    if (this.rackCodeLength > 0) {

      if (rackCodeChar.includes('*')) {
        this.rackCodeLength -= 1;
      }
      if (this.rackCodeLength < 8 && this.rackCodeLength > 2) {
        this.getRackCodeData(this.rackCodeInput.nativeElement.value);
        this.rackCodeFilteredOptions = this._filter(this.rackCodeInput.nativeElement.value);
      }
      if (this.rackCodeLength < 3) {
        this.rackCodeFilteredOptions = [];
        this.noRackCodeRecords = '';
      }
    } else {
      this.rackCodeFilteredOptions = [];
      this.noRackCodeRecords = '';
    }

  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  getBuildingNumbers() {
    this.pfepService.getBuildingData().subscribe(response => {
      const buildingNumberArray = response.result;
      if (response.status && response.status.statusCode === 200) {
        this.buildingNumberList = [...this.buildingNumberList, ...buildingNumberArray];
      }
    });
  }

  getRackTableData(type?) {
    const initialObj = {
      'pageNo': 0,
      'pageSize': this.pageSize,
    };
    this.spinner.show();
    this.pfepService.getRackData(initialObj).subscribe(response => {
      const rackData = response.result;
      if (response.status && response.status.statusCode === 200) {
        this.spinner.hide();
        this.length = response.result.totalCount;
        if (type === 'onUpdate') {
          this.downloadRackData = response.result.data;
          this.dataSource = new MatTableDataSource<RackTableData>(response.result.data);
        } else {
          this.downloadRackData = response.result.data;
          this.dataSource = new MatTableDataSource<RackTableData>(response.result.data);
        }
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    }, error => {
      this.spinner.hide();
    });
  }

  handleRackPage(event, totalData) {
    const searchObj = {
      'buildingNos': this.buildingsArr,
      'code': this.rackCodeInput.nativeElement.value,
      'pageNo': event.pageIndex,
      'pageSize': event.pageSize,
    };
    this.pageSize = event.pageSize;
    this.pfepService.getRackData(searchObj).subscribe(response => {
      const rackData = response.result;
      if (response.status && response.status.statusCode === 200) {
        this.length = response.result.totalCount;
        this.downloadRackData = response.result.data;
        this.dataSource = new MatTableDataSource<RackTableData>(response.result.data);
      }
    }, error => {
      this.spinner.hide();
    });
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  sortData(event) {
    const searchObj = {
      'orderBy': event.direction,
      'pageNo': 0,
      'pageSize': this.pageSize,
      'sortBy': event.active
    };
this.spinner.show();
    this.pfepService.rackDataBySearch(searchObj).subscribe(response => {
      if (response && response.status && response.status.statusCode === 200) {
        this.spinner.hide();
        this.length = response.result.totalCount;
        this.dataSource = response.result.data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.downloadRackData = response.result.data;
      }
    }, error => {
      this.spinner.hide();
    });
  }
  onBuildingChange(event) {
    this.buildingArrLength = this.buildings.value.length;
  }
  searchByBuildingNumber() {
    this.buildingsArr = [...this.buildings.value];
    if (this.buildingsArr.length === 0) {
      return;
    }
    const searchObj = {
      'buildingNos': this.buildingsArr,
      'pageNo': 0,
      'pageSize': this.pageSize,
    };
    this.spinner.show();
    this.pfepService.rackDataBySearch(searchObj).subscribe(response => {
      if (response && response.status && response.status.statusCode === 200) {
        this.spinner.hide();
        this.length = response.result.totalCount;
        this.dataSource = new MatTableDataSource<RackTableData>(response.result.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.downloadRackData = response.result.data;
      }
    }, error => {
      this.spinner.hide();
    });
  }
  searchByRackCode() {
    if (this.rackCodeInput.nativeElement.value.length < 3) {
      return;
    }
    const searchObj = {
      'code': this.rackCodeInput.nativeElement.value,
      'pageNo': 0,
      'pageSize': this.pageSize,
    };
    this.spinner.show();
    this.pfepService.rackDataBySearch(searchObj).subscribe(response => {
      if (response && response.status && response.status.statusCode === 200) {
        this.spinner.hide();
        this.length = response.result.totalCount;
        this.dataSource = new MatTableDataSource<RackTableData>(response.result.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.downloadRackData = response.result.data;
      }
    }, error => {
      this.spinner.hide();
    });
  }
  resetSearch() {
    const searchObj = {
      'pageNo': 0,
      'pageSize': this.pageSize,
    };
    this.spinner.show();
    this.pfepService.rackDataBySearch(searchObj).subscribe(response => {
      if (response && response.status && response.status.statusCode === 200) {
        this.spinner.hide();
        this.rackCodeInput.nativeElement.value = '';
        this.rackCodeFilteredOptions = [];
        this.buildingsArr = [];
        this.buildingArrLength = 0;
        this.rackCodeLength = 0;
        this.noRackCodeRecords = '';
        this.buildings.reset();
        this.rackCode.reset();
        this.length = response.result.totalCount;
        this.dataSource = response.result.data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.downloadRackData = response.result.data;
      }
    }, error => {
      this.spinner.hide();
    });
  }
  onBuildingRemoved(build: any): void {
    const updateBuilding = this.buildings.value as string[];
    this.removeFirst(updateBuilding, build);
    this.buildings.setValue(updateBuilding);
    this.buildingArrLength = this.buildings.value.length;
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
  // changeFont(operator) {
  //   operator === '+' ? this.fontSize++ : this.fontSize--;
  //   (this.rackPage.nativeElement as HTMLParagraphElement).style.fontSize = `${this.fontSize}px`;
  // }

  onFileChange(event) {
    this.file = event.target.files[0];
    this.openRackUploadDialog(this.file);
  }

  openRackUploadDialog(file): void {
    // tslint:disable-next-line: prefer-const
    let dialogRef = this.dialog.open(ModalOverviewComponent, {
      width: 'auto',
      disableClose: true,
      data: { type: 'Rack', file: file }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'updateData') {
        this.getRackTableData('onUpdate');
      }
      this.file = null;
      this.rackInput.nativeElement.value = null;
      dialogRef.close();
    });
  }

  editRow(editedRow) {
    // tslint:disable-next-line: prefer-const
    let dialogRef = this.dialog.open(ModalOverviewComponent, {
      minWidth: 'auto',
      maxWidth: '95vw',
      disableClose: true,
      data: { type: 'EditRack', rackData: editedRow }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'updateData') {
        this.getRackTableData('onUpdate');
      }
      dialogRef.close();
    });
  }
  goTo() {
    this.router.navigateByUrl('dashboard');
  }
  downloadRackCodesTemplate() {
    window.location.assign(environment.rackUpload_saas);
  }
  downloadRackCSV() {
    if (this.buildingsArr.length === 0 &&
       (this.rackCodeInput.nativeElement.value === null || this.rackCodeInput.nativeElement.value === '')) {
      const searchObj = {
        'pageSize': 5000,
      };
      this.pfepService.getRackData(searchObj).subscribe(response => {
        this.rackDownloadValues = response.result.data;
        this.exportRackDownloadData(this.rackDownloadValues);
      });
    } else if (this.buildingsArr.length !== 0 ) {
      const searchObj = {
        'buildingNos': this.buildingsArr,
        'pageSize': 5000,
      };
      this.pfepService.getRackData(searchObj).subscribe(response => {
        if (response && response.status && response.status.statusCode === 200) {
          this.rackDownloadValues = response.result.data;
          this.exportRackDownloadData(this.rackDownloadValues);
        }
      });
    } else if (this.buildingsArr.length === 0 &&
      (this.rackCodeInput.nativeElement.value !== null || this.rackCodeInput.nativeElement.value !== '') ) {
      const searchObj = {
        'code': this.rackCodeInput.nativeElement.value,
        'pageSize': 5000,
      };
      this.pfepService.getRackData(searchObj).subscribe(response => {
        if (response && response.status && response.status.statusCode === 200) {
          this.rackDownloadValues = response.result.data;
          this.exportRackDownloadData(this.rackDownloadValues);
        }
      });
    }
  }

  exportRackDownloadData(data) {
    let exportRackData = [];
    data.forEach(element => {
    let rackObj = {};
      rackObj['Rack Code'] = element.rackCode;
      rackObj['Driving Direction'] = element.drivingDirection;
      rackObj['X'] = element.x;
      rackObj['Y'] = element.y;
      rackObj['Depth(X)'] = element.depth;
      rackObj['Width(Y)'] = element.width;
      rackObj['Height(Z)'] = element.height;
      rackObj['BuildingNumber'] = element.building;
      rackObj['Shelf Count'] = element.shelfCount;
      rackObj['Column Count'] = element.columnCount;
      exportRackData.push(rackObj);
    });
    let options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      // tslint:disable-next-line: max-line-length
      headers: ['Rack Code', 'Driving Direction', 'X', 'Y', 'Depth(X)', 'Width(Y)', 'Height(Z)', 'BuildingNumber', 'Shelf Count', 'Column Count']
    };
    // tslint:disable-next-line: no-unused-expression
    new AngularCsv(exportRackData, 'Rack Data', options);
    this.spinner.hide();
  }
  showHistory(rackHistory) {
    let dialogRef = this.dialog.open(PfepHistoryComponent, {
      minWidth: '95vw',
      disableClose: true,
      data: { type: 'RackHistory', rackHistoryData: rackHistory }
    });

    dialogRef.afterClosed().subscribe(result => {
        dialogRef.close();
    });
  }
  openAddRack() {
    let dialogRef = this.dialog.open(AddRackNoubaPopupComponent, {
      minWidth: 'auto',
      maxWidth: '97vw',
      disableClose: true,
      data: { type: 'AddRackData'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'updateData') {
        this.getRackTableData('onUpdate');
      }
        dialogRef.close();
    });
  }
  deleteRackData(rackCode) {
    this.bulkDeleteRack = [];
    this.bulkDeleteRack.push(rackCode);
    let dialogRef = this.dialog.open(AddRackNoubaPopupComponent, {
      width: 'auto',
      disableClose: true,
      data: { type: 'DeleteRackData', rackCode: this.bulkDeleteRack}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'updateData') {
        this.bulkDeleteRack = [];
        this.getRackTableData('onUpdate');
      }
      this.bulkDeleteRack = [];
      this.selection.clear();
        dialogRef.close();
    });
  }
  isAllSelected() {
    this.bulkDeleteRack = [];
    // console.log("test:",this.selection.selected);
    if (this.selection.selected.length) {
      this.selection.selected.forEach(element => {
        this.bulkDeleteRack.push(element.rackCode);
      });
    }
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.bulkDeleteRack = [];
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
    if (this.selection.selected.length) {
      this.selection.selected.forEach(element => {
        this.bulkDeleteRack.push(element.rackCode);
      });
    }
  }
  deleteBulkData() {
    // console.log("bulkDeleteRack:",this.bulkDeleteRack);
    let dialogRef = this.dialog.open(AddRackNoubaPopupComponent, {
      width: 'auto',
      disableClose: true,
      data: { type: 'DeleteRackData', rackCode: this.bulkDeleteRack}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'updateData') {
        this.bulkDeleteRack = [];
        this.getRackTableData('onUpdate');
      }
      this.bulkDeleteRack = [];
      this.selection.clear();
        dialogRef.close();
    });
  }
}
